import { default as HttpStatus } from 'http-status';

export interface ErrorResponse<TData = unknown> {
  status: number;
  data: TData;
}

export const ERRORS: { [key: string]: number } = {
  ALREADY_REPORTED: HttpStatus.ALREADY_REPORTED,
  BAD_REQUEST: HttpStatus.BAD_REQUEST,
  CONFLICT: HttpStatus.CONFLICT,
  FORBIDDEN: HttpStatus.FORBIDDEN,
  GONE: HttpStatus.GONE,
  SERVICE_NO_LONGER_POSSIBLE: HttpStatus.NO_CONTENT,
  SERVICE_NOT_AVAILABLE: HttpStatus.INTERNAL_SERVER_ERROR,
  SERVICE_NOT_FOUND: HttpStatus.NOT_FOUND,
  SESSION_TIMED_OUT: HttpStatus.FORBIDDEN,
  TOO_SOON_TO_GET_SERVICE: HttpStatus.CONFLICT,
};
